import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'
import { useFocus } from './focus'
import { useScoreEvent } from './metaScore'
import { assess, startScores } from './scorer'

// The visitor's seven scores and what they add up to. The scorer's sliders set them; the scorer's result and
// the ladder further down the page both read them.
const ScoresContext = createContext(null)

export const ScoresProvider = ({ children }) => {
  const { scorer, key: page } = useFocus()
  const [scores, setScores] = useState(() => startScores(scorer))
  // the example scores are the page's, not the visitor's: nothing is reported until a slider moves
  const [touched, setTouched] = useState(false)
  const set = useCallback((key, score) => {
    setTouched(true)
    setScores((current) => ({ ...current, [key]: score }))
  }, [])
  const reset = useCallback(() => setScores(startScores(scorer)), [scorer])
  const result = useMemo(() => assess(scorer, scores), [scorer, scores])
  useScoreEvent({ result, touched, page })
  const value = useMemo(() => ({ scores, set, reset, result }), [scores, set, reset, result])
  return <ScoresContext.Provider value={value}>{children}</ScoresContext.Provider>
}

export const useScores = () => useContext(ScoresContext)
